import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/style.css';

import $ from 'jquery';
window.$ = window.jQuery = $;

import 'popper.js';
import 'bootstrap';

import './custom.js';
